import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function EnterpriseCTA() {
  const navigate = useNavigate();
  return (
    <section className="section-padding">
      <div className="container-width">
        <motion.div
          className="
            w-full
            rounded-2xl
            px-6 sm:px-8 md:px-12
            py-8 sm:py-10 md:py-12
            bg-primary
            text-white
            flex flex-col md:flex-row
            md:items-center
            gap-6 md:gap-10
          "
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          {/* LEFT - HEADLINE */}
          <div className="w-full md:w-[30%]">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold leading-tight">
              Get a Custom Quote for Your Document Workflows
            </h2>
          </div>

          {/* MIDDLE - DESCRIPTION */}
          <div className="w-full md:w-[45%] text-sm sm:text-base text-white/90 leading-relaxed">
            Every business processes documents differently. Our team will help
            you estimate pricing based on your document volume, workflow
            complexity, and integration needs.
          </div>

          {/* RIGHT - BUTTON */}
          <div className="w-full md:w-[25%] flex md:justify-end">
            <button
              onClick={() => navigate("/contact-us")}
              className="
              w-full sm:w-auto
              bg-secondary
              px-6 py-3
              rounded-[4px]
              text-sm font-medium
              text-white
              hover:bg-tertiary
              transition
            "
            >
              Talk to an Expert
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
